import { discussions } from "@/mocks/community";
import SectionHeading from "./SectionHeading";

export default function Discussion() {
  return (
    <section id="discussion" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="讨论专区"
          title="四大板块，畅所欲言"
          desc="按兴趣划分讨论专区，剧情研读、安利分享、同人创作、新手答疑，总有一块属于你。"
        />

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {discussions.map((board) => (
            <a
              key={board.id}
              href="#discussion"
              className="group flex flex-col rounded-2xl border border-background-200 bg-gradient-to-b from-background-100 to-background-50 p-6 transition-all hover:-translate-y-1 hover:border-secondary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className={`${board.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{board.board}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{board.desc}</p>
              <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-file-list-3-line"></i>
                  {board.topics.toLocaleString()} 话题
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-message-3-line"></i>
                  {board.posts.toLocaleString()} 帖子
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-primary-100 p-8 text-center md:p-12">
          <div className="mx-auto flex max-w-2xl flex-col items-center gap-4">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-1.5 text-xs font-medium text-background-50">
              <i className="ri-lightbulb-flash-line"></i>
              互动小贴士
            </span>
            <h3 className="font-heading text-xl font-bold text-primary-900 md:text-2xl">
              好的讨论，从一份友善的回复开始
            </h3>
            <p className="text-sm leading-relaxed text-primary-800/90">
              理性表达、互相尊重，是我们社区最温暖的底色。无论是热烈争论还是温柔安利，
              都欢迎你在讨论区留下自己的声音。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}